/**
 * Gets a document cookie by name
 * @param {String} name - The name of the cookie
 * @returns {String, Null} - Either the value of the cookie (if found) or null (if not found)
 */
window.getDocumentCookie = (name) => {
  var matchingCookie = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"))
  return matchingCookie ? matchingCookie[2] : null
}

var productFormPrice = 0;
var productUpSellTotal = 0;

/**
 * Sets a document cookie
 * @param {String} name - The name of the cookie
 * @param {Boolean} persisting - Whether the cookie should persist (for 999 days), if not then a session cookie is set instead.
 */
window.createDocumentCookie = (name, persisting = true, value = null) => {
  var expires = ""
  if (persisting) {
    var date = new Date()
    date.setTime(date.getTime() + 86313600000)
    expires = "; expires=" + date.toUTCString()
  }
  document.cookie = name + "=" + (value || "true") + expires + "; path=/"
}

window.updateQuantity = (direction) => {
  var qty_box = document.getElementById("quantity")
  var current_qty = document.getElementById("quantity").value
  if (isNaN(current_qty)) {
  } else {
    if (direction == "plus") {
      qty_box.value++
    }
    if (direction == "minus") {
      if (current_qty > 0) {
        qty_box.value--
      }
    }
  }
}

window.scrollToElem = (selector, yOffset = 0) =>{
  const el = document.querySelector(selector);
  const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

  window.scrollTo({top: y, behavior: 'smooth'});
}

window.updateVariantImage = (value) => {
  var variantSelected = document.querySelector('.pdp-main__variant input[type=radio]:checked+label.pdp-main__variant-info');
  if (variantSelected) {
    var variantSelectedId = variantSelected.getAttribute("for");
    var imageQueryString = `[data-id="`+variantSelectedId+`"]` 
    var selectedVariantImage = document.querySelector(imageQueryString);

    if (window.innerWidth > 992 ){
      //selectedVariantImage.scrollIntoView({block: "end"});
      //call scrollToElem function scrollIntoView End was causing display errors
      window.scrollToElem(imageQueryString,-68);
    } else {
      document.body.dispatchEvent(
        new CustomEvent("swiperUpdateVariantImage", {
          detail: {
            string: variantSelectedId
          }
        })
      );
    }
  }
}

window.upSellPriceUpdate = () => {
  var priceDisplay = document.querySelector(".pdp-main__price")
  if (priceDisplay) {
    priceDisplay.innerText = "$" + (productFormPrice + productUpSellTotal)
  }

  var ctaPriceDisplay = document.querySelector(".pdp-main__atc-price")
  if(ctaPriceDisplay) {
    ctaPriceDisplay.innerText = "$" + (productFormPrice + productUpSellTotal)
  }
}

window.updatePrice = (price, option, optionname) => {
  productFormPrice = Number(price.split(price[0])[1])

  var priceDisplay = document.querySelector(".pdp-main__price")
  if (priceDisplay) {
    if (productUpSellTotal === 0) {
      priceDisplay.innerText = "$" + productFormPrice;
    } else {
      priceDisplay.innerText = "$" + (productFormPrice + productUpSellTotal)
    }
  }

  var sizeUpdate = document.querySelector('.pdp-main__variant-text--quantity')
  if (sizeUpdate){
    sizeUpdate.innerText = ' '+ optionname +' ('+option+')'
  }
}

window.updateAvailability = (availability) => {
  var atcButton = document.querySelector(".pdp-main__submit")
  if (!atcButton) return;


  var mainPriceRef = document.querySelector("[data-main-price]");

  if(mainPriceRef !== null && productFormPrice === 0) {
    productFormPrice = Number(mainPriceRef.dataset.mainPrice);
  }

  if (availability == "true") {
    atcButton.removeAttribute("disabled")
    atcButton.innerHTML = atcButton.dataset.initial + ' ' + '<svg class="pdp-main__atc-spacer" width="2" height="17" viewBox="0 0 2 17" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="1.18359" y1="16.1016" x2="1.1836" y2="0.101562" stroke="white"/></svg>' + '<span class="pdp-main__atc-price">' + '$' + (productFormPrice + productUpSellTotal) + '</span>'
  } else {
    atcButton.setAttribute("disabled", "disabled")
    atcButton.innerText = atcButton.dataset.soldOut
  }
}

window.toggleNearestExpandingRow = (trigger) => {
  var expandingRow = trigger.parentElement.parentElement.querySelector(".expandingRow")
  if (expandingRow && expandingRow.classList.contains("active")) {
    expandingRow.classList.remove("active")
    trigger.style.transform = "rotateX(0)"
  } else if (expandingRow) {
    expandingRow.classList.add("active")
    trigger.style.transform = "rotateX(180deg)"
  }
}

window.createElementWith = function (elementType, attributes = {}, content) {
  var element = document.createElement(elementType)
  for (var key in attributes) {
    element.setAttribute(key, attributes[key])
  }
  element.innerHTML = content || ""
  return element
}

// Collection Filter for Roses collection //
document.addEventListener("click", (e) => {
  if (e.target.matches("[data-collection-item]")) {
    sessionStorage.setItem("collection", "standard")
  }
  if (e.target.matches(".header__desktop-menu__list-link") || e.target.matches(".footer__main__list-link")) {
    sessionStorage.setItem("collection", "roses")
  }
})
